/**
 * /tenants/$tenantId — platform-side tenant detail (LADM-03).
 *
 * The drill-in from a tenant-list row: identity, subscription, billing
 * history, and this tenant's audit trail. Home for the subscription
 * lifecycle actions (A3).
 */
import { createFileRoute } from "@tanstack/react-router";
import { TenantDetailScreen } from "../features/tenants/TenantDetailScreen";

export const Route = createFileRoute("/_auth/tenants/$tenantId/")({
  staticData: {
    breadcrumb: { labelKey: "link-admin:tenants.detail.breadcrumb" },
  },
  component: TenantDetailScreen,
});
